import { Button, Modal, Box } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "80%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  borderRadius:"10px"
};

function LogoutModal(props) {
  return (
    <Modal open={props.open} onClose={props.onClose}>
      <>
        <Box sx={style}>
          <p>Are you sure you want to Logout ?</p>
          <Box>
            <Button
              id="modal-yes-btn"
              variant="contained"
              onClick={props.onConfirmLogout}
            >
              Yes
            </Button>
            <Button
              id="modal-no-btn"
              variant="contained"
              onClick={props.onClose}
            >
              No
            </Button>
          </Box>
        </Box>
      </>
    </Modal>
  );
}

export default LogoutModal;
